/**
 * Language Provider Helper Component
 * Used to Display Localised Strings
 */
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

interface InjectMassageProps {
  id?: string;
  defaultMessage?: string;
  [key: string]: any;
}

// Injected message with graceful fallback for missing translations
const humanize = (text: string): string =>
  (text.split('.').pop() || '')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[-_]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());

const InjectMassage: React.FC<InjectMassageProps> = ({ id = '.', defaultMessage, ...rest }) => {
  const fallback = defaultMessage || humanize(id);
  return <FormattedMessage id={id} defaultMessage={fallback} {...rest} />;
};

export default injectIntl(InjectMassage, {
  withRef: false,
  pure: true,
});
